class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    // Verhindert, dass der Klick auf Summary sofort das Body-Click-Event auslöst
    event.stopPropagation(); 
    
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    
    // Kleines Timeout verhindert, dass der öffnende Klick selbst direkt wieder als Body-Click gewertet wird
    setTimeout(() => {
      document.body.addEventListener('click', this.onBodyClickEvent);
    }, 50);

    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    if (this.onBodyClickEvent) {
      document.body.removeEventListener('click', this.onBodyClickEvent);
    }
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);


// Schutz gegen externe DOM-Eingriffe (Pop Convert App) mit Mouse-Down-Fix
const searchModal = document.querySelector('details-modal.header__search');
if (searchModal) {
  const details = searchModal.querySelector('details');
  let userIntentToClose = false;

  // Reagiere bereits beim Runterdrücken der Maustaste (bevor der Fokus verloren geht)
  searchModal.querySelectorAll('button, .modal-overlay').forEach(el => {
    el.addEventListener('mousedown', () => userIntentToClose = true);
    el.addEventListener('touchstart', () => userIntentToClose = true, { passive: true });
  });

  details.addEventListener('keyup', (e) => {
    if (e.code.toUpperCase() === 'ESCAPE') userIntentToClose = true;
  });

  const summary = searchModal.querySelector('summary');
  if (summary) {
    summary.addEventListener('mousedown', () => {
      userIntentToClose = false;
    });
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        if (!details.hasAttribute('open') && !userIntentToClose) {
          details.setAttribute('open', '');
        }
      }
    });
  });

  observer.observe(details, { attributes: true });
}